import React from 'react';
import { FiEdit2 } from 'react-icons/fi';
import { API_URL } from '../Utils/Constant';
import BlogForm from './BlogForm';

const BlogEdit = ({ blogs, editingBlog, setEditingBlog, handleEdit }) => {
    return (
        <div className="p-6">
            <h2 className="text-2xl font-bold mb-6 text-gray-800">
                {editingBlog ? 'Edit Blog' : 'Select Blog to Edit'}
            </h2>
            {editingBlog ? (
                <BlogForm
                    key={`edit-form-${editingBlog._id}`}
                    blog={editingBlog}
                    onBack={() => setEditingBlog(null)}
                />
            ) : (
                <div className="grid grid-cols-1 gap-6">
                    {blogs.map((allblog) => (
                        <div key={allblog._id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                            <div className="flex flex-col md:flex-row">
                                <div className="md:w-1/3">
                                    <img
                                        src={allblog.image}
                                        alt={allblog.title}
                                        className="w-full h-48 object-fill"
                                    />
                                </div>
                                <div className="md:w-2/3 p-4">
                                    <h3 className="text-xl font-semibold mb-2 text-gray-800">{allblog.title}</h3>
                                    <p className="text-gray-600 mb-4 line-clamp-2">{allblog.content}</p>
                                    <div className="flex justify-between items-center">
                                        <span className="text-sm text-gray-500">By {allblog.author}</span>
                                        <button
                                            onClick={() => handleEdit(allblog)}
                                            className="px-4 py-2 bg-secondary text-white rounded-lg hover:bg-secondary/90 transition-colors flex items-center gap-2"
                                        >
                                            <FiEdit2 className="w-4 h-4" />
                                            Edit Blog
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default BlogEdit;
